import React from "react";

const SectionIntro = ({
  eyebrow,
  title,
  headingTag = "h2",
  alignment = "left",
  children,
}) => {
  const HeadingTag = headingTag;
  const resolvedAlignment = alignment === "center" ? "center" : "left";

  return (
    <header className={`section-intro section-intro--${resolvedAlignment}`}>
      {eyebrow && <p className="section-intro__eyebrow">{eyebrow}</p>}
      {title && (
        <HeadingTag className="section-intro__title">{title}</HeadingTag>
      )}
      {children && <div className="section-intro__body">{children}</div>}
    </header>
  );
};

export default SectionIntro;
